import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
  title = 'Nathan Martins - Frontend Developer & UI/UX Designer',
  description = 'Frontend developer specializing in React, WebFlow, and UI/UX design. Helping businesses create engaging digital experiences in Amsterdam and beyond.',
  keywords = 'frontend developer, React, WebFlow, UI/UX design, Amsterdam, portfolio, web design, digital marketing',
  image = '/og-image.jpg',
  url = 'https://nathan.marketing',
  type = 'website',
  siteName = 'Nathan Martins',
  author = 'Nathan Martins',
  locale = 'en_US',
  robots = 'index, follow',
  canonical = 'https://nathan.marketing',
  publishedTime = null,
  modifiedTime = null,
  section = null,
  tags = null,
  category = null,
}) => {
  const fullUrl = canonical + url;
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Nathan Martins',
    url: 'https://nathan.marketing',
    sameAs: [
      'https://linkedin.com/in/nathanmartins',
      'https://github.com/nathanmartins',
      'https://twitter.com/nathanmartins'
    ],
    jobTitle: 'Frontend Developer & UI/UX Designer',
    knowsAbout: [
      'React',
      'JavaScript',
      'HTML',
      'CSS',
      'UI Design',
      'UX Design',
      'WebFlow',
      'Frontend Development',
      'Digital Marketing',
      'SEO',
      'Amsterdam'
    ],
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Amsterdam',
      addressCountry: 'Netherlands'
    },
    email: 'mailto:nathan@nathan.marketing'
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content={robots} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={locale} />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@nathanmartins" />
      <meta name="twitter:creator" content="@nathanmartins" />
      
      {/* Additional SEO Tags */}
      <meta name="theme-color" content="#115744" />
      <meta name="msapplication-TileColor" content="#115744" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      
      {/* Favicon */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
      <link rel="manifest" href="/manifest.json" />
    </Helmet>
  );
};

export default SEO;